module.exports = __webpack_public_path__ + "media/assets/images/blog/ha_partnership_leanbit-small-f66c43ad332660a37078d6ba04eee2fb.jpg";